<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-summary-payment-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
        <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="系統單號" width="92" align="left" fixed>
            <template slot-scope="scope">
                <span @click="$event => onClick($event, scope.row.sno)" style="font-size: 8.5pt;">{{ scope.row.uniqueNumber }}</span>
            </template>
        </el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.approvedVocherQty === 0 }">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" min-width="300" class-name="strong" fixed show-overflow-tooltip />
        <el-table-column prop="iteM_NAM" label="支出項目" min-width="120" class-name="strong" show-overflow-tooltip />
        <el-table-column label="請款單日期" width="100" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="documentCount" label="憑證" min-width="70" align="center" />
        <el-table-column prop="amount" label="單據總額" class-name="blue strong" align="right" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.amount" :precision="scope.row.cny === 'TWD' ? null : 4" />
            </template>
        </el-table-column>
        <el-table-column prop="taX_AMT" label="代扣所得稅" class-name="blue strong" align="right" width="100">
            <template slot-scope="scope">
                <Money :v="scope.row.taX_AMT * scope.row.rat" round />
                <div v-if="scope.row.cny !== 'TWD'" style="color: #aaa; margin-top: -5px;">(TWD)</div>
            </template>
        </el-table-column>
        <el-table-column prop="geN2_AMT" label="代扣二代健保" class-name="blue strong" align="right" width="100">
            <template slot-scope="scope">
                <Money :v="scope.row.geN2_AMT * scope.row.rat" round />
                <div v-if="scope.row.cny !== 'TWD'" style="color: #aaa; margin-top: -5px;">(TWD)</div>
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="實付金額" class-name="blue strong" align="right" width="110">
            <template slot-scope="scope">
                <Money :v="scope.row.amount - scope.row.taX_AMT - scope.row.geN2_AMT" :precision="scope.row.cny === 'TWD' ? null : 4" />
            </template>
        </el-table-column>
        <el-table-column prop="cny" label="幣別" class-name="blue" min-width="70" align="center" />
        <el-table-column prop="rat" label="匯率" class-name="blue" min-width="75" align="right" />
        <el-table-column prop="amount" label="付款方式" class-name="yellow" min-width="110" align="center">
            <template slot-scope="scope"> {{ getPayWayText(scope.row.paY_WAY) }} </template>
        </el-table-column>
        <el-table-column prop="incomeBnkDat" label="付款日期" class-name="yellow" min-width="100" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="付款總額" class-name="yellow strong" min-width="110" align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.amount - scope.row.taX_AMT - scope.row.geN2_AMT" />
                <div v-if="scope.row.cny !== 'TWD'" style="color: #aaa;">{{ scope.row.cny }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="bankName" label="銀行帳戶" class-name="yellow" min-width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ scope.row.bankName || "--" }}</span>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="foO_DIS_AMT" label="進貨折讓總額" class-name="red" min-width="110" align="right">
            <template slot-scope="scope">
                <Money v-if="scope.row.foO_DIS" :v="scope.row.foO_DIS_AMT" />
                <span v-else> -- </span>
            </template>
        </el-table-column> -->
        <el-table-column label="建立日期" width="100" align="center">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onClick(e, sno) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('openReceipt', sno);
        },
        onRowClick(data) {
            this.$emit('openDetail', data.sno, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-payment-table {
    .el-table__body-wrapper {
    }
    .blue {
        background-color: #f1f4ff;
    }
    .yellow {
        background-color: #fffde7;
    }
    .red {
        background-color: #fff5f5;
    }

    .el-table__row {
        cursor: pointer;
    }
}
</style>
